import { render, staticRenderFns } from "./ServiceQueues.vue?vue&type=template&id=137fc016&"
import script from "./ServiceQueues.vue?vue&type=script&lang=ts&"
export * from "./ServiceQueues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/StratusCAD/ModelPipelineClient/model-pipeline-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137fc016')) {
      api.createRecord('137fc016', component.options)
    } else {
      api.reload('137fc016', component.options)
    }
    module.hot.accept("./ServiceQueues.vue?vue&type=template&id=137fc016&", function () {
      api.rerender('137fc016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/servicequeues/ServiceQueues.vue"
export default component.exports